import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function LesserPoland() {
  return (
    <>
      <DisplayMaster voivodeship="LesserPoland" />
    </>
  );
}